import {Style, Fill, Stroke, Icon, Text} from 'ol/style.js';
import {transformExtent} from 'ol/proj';
import {GeoJsonLayer} from '../GeoJsonLayer.js';
import Library from '../Library.js';

export class FeatureLayer extends GeoJsonLayer {
    icon_cache = {};

    constructor( map, settings = {}){
        settings["name"] = 'feature';
        settings["api_endpt"] = "FeatureJSON.php";
        if( settings['labels'] == undefined ) settings["labels"] = false;
        if( settings['scale'] == undefined ) settings["scale"] = 1;
        super( map, settings );
    }

    getUrl( extent, resolution, projection ){
        let extent1 = transformExtent(extent, projection, "EPSG:4326");
        let url = new URL( this.api_path + "/" + this.api_endpt );
        url.searchParams.set( "bbox", extent1.join(","));
        url.searchParams.set( "zoom", this.map.view.getZoom());
        return url.toString();
    }

    getIconSize( feature ){
        return this.settings['scale']*20;
    }

    getIcon( feature ){
        let params = "";
        if( this.property(feature,'type') == "VOL" )
            params = params + "code=VOLC";
        if( this.property(feature,'type') == "MTN" )
            params = params + "code=MNTN";
        if( this.property(feature,'type') == "PAS" ){
            params = params + "code=PASS";
            if( this.property(feature,'dir') == 'NNE')
                params = params + "&dir=23";
            else if( this.property(feature,'dir') == 'NE')
                params = params + "&dir=45";
            else if( this.property(feature,'dir') == 'ENE')
                params = params + "&dir=78";
            else if( this.property(feature,'dir') == 'E')
                params = params + "&dir=90";
            else if( this.property(feature,'dir') == 'ESE')
                params = params + "&dir=113";
            else if( this.property(feature,'dir') == 'SE')
                params = params + "&dir=135";
            else if( this.property(feature,'dir') == 'SSE')
                params = params + "&dir=158";
            else if( this.property(feature,'dir') == 'S')
                params = params + "&dir=180";
            else if( this.property(feature,'dir') == 'SSW')
                params = params + "&dir=203";
            else if( this.property(feature,'dir') == 'SW')
                params = params + "&dir=225";
            else if( this.property(feature,'dir') == 'WSW')
                params = params + "&dir=248";
            else if( this.property(feature,'dir') == 'W')
                params = params + "&dir=270";
            else if( this.property(feature,'dir') == 'WNW')
                params = params + "&dir=293";
            else if( this.property(feature,'dir') == 'NW')
                params = params + "&dir=315";
            else if( this.property(feature,'dir') == 'NNW')
                params = params + "&dir=333";
        }
        if( this.property(feature,'type') == "STD" )
            params = params + "code=STAD&color=803050";
        if( this.property(feature,'type') == "CAM" )
            params = params + "code=CAM&color=0000FF";
        if( this.settings['scale'] != 1 )
            params = params + "&scale="+this.settings['scale'];
        return this.icon_path+'/wxicon.php?'+params;
    }

    getLabel( feature ){
        let str = "";
        if( this.settings['labels'] == true ){
            str = this.property(feature,'name').substr(0,10);
        }
        return str;
    }

    getPopupText( feature ){
        let type = this.property(feature,'type');
        if( type == "VOL" ) type = "Volcano";
        if( type == "MTN" ) type = "Mountain";
        if( type == "PAS" ) type = "Mtn Pass";
        if( type == "STD" ) type = "Stadium";
        if( type == "CAM" ) type = "Camera";

        let text = this.popupTitle( "FEATURE", type );
        var name = this.property(feature,'name');
        text += this.popupData( "Name", name );
        var htm = this.property(feature,'elev');
        var htf = Math.round(htm*3.28);
        text += this.popupData( "Elevation", htm+"m ("+htf+"ft)" );
        if( this.property(feature,'height') != undefined ){
            var htm = this.property(feature,'height');
            var htf = Math.round(htm*3.28);
            text += this.popupData( "Height AGL", htm+"m ("+htf+"ft)" );
        }
        text += this.popupEnd();
        return text;
    }

    getStyle(feature, resolution ){
        let size = this.getIconSize(feature);
        let icon;
        if( this.icon_cache[feature.getId()] )
            icon = this.icon_cache[feature.getId()];
        else {
            icon = new Icon({
                    "src": this.getIcon(feature),
                    "imgSize": [size,size]
                    });
            this.icon_cache[feature.getId()] = icon;
        }
        let style = new Style({
                "image": icon,
                "text": new Text({
                        "font": "12px",
                        "fill": new Fill({
                                "color": "black"
                                }),
                        "text": this.getLabel(feature),
                        "stroke": new Stroke({"color": "white", "width": 2 }),
                        "offsetX": -20,
                        "offsetY": 12
                        })
                });
        return style;
    }

}
